import { ReportStatus } from 'src/api';
import { ReportStatus as ReportStatusGQL } from 'src/graphql';
import theme from 'src/theme/theme';
import { DefaultTheme } from 'styled-components';

export const reportStatusToColor = (
  reportStatus: ReportStatus | ReportStatusGQL | undefined,
  t?: DefaultTheme,
) => {
  if (t && !t.isVaultVariant) {
    switch (reportStatus) {
      case ReportStatus.READ:
        return t.atlas.semantic.color.action.primary.default;
      case ReportStatus.INVESTIGATING:
        return t.atlas.semantic.color.status.warning.default;
      case ReportStatus.CLOSED:
        return t.atlas.semantic.color.type.muted;
      case ReportStatus.DRAFT:
        return t.atlas.semantic.color.type.default;
      default:
        return t.atlas.semantic.color.action.primary.default;
    }
  }
  switch (reportStatus) {
    case ReportStatus.READ:
      return theme.newPalette.turquoise.T300;
    case ReportStatus.INVESTIGATING:
      return theme.newPalette.yellow.Y300;
    case ReportStatus.CLOSED:
      return theme.newPalette.neutral.N600;
    case ReportStatus.DRAFT:
      return theme.newPalette.neutral.N800;
    default:
      return theme.newPalette.chart.blue;
  }
};

export const chartColors = Object.values(theme.newPalette.chart);
